<div class="soa-product-volumes-container">
    <div class="soa-product-volumes-title">Product Volumes</div>
    @if(productSoaCount && productSoaCount.length > 0) {
    <p-chart #chart class="soa-product-volumes-chart" type="bar" [data]="data" [options]="options"></p-chart>
    } @else {
    <app-no-result-found></app-no-result-found>
    }
</div>